module.exports = __webpack_public_path__ + "static/media/alupro.ff6d7511.jpg";